/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ itemName: NonNullable<unknown>, current: NonNullable<unknown>, previous: NonNullable<unknown> }} Notifications_Email_Subject_Price_DropInputs */

const he_notifications_email_subject_price_drop = /** @type {(inputs: Notifications_Email_Subject_Price_DropInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`ירידת מחיר: ${i?.itemName} — ${i?.current} (היה ${i?.previous})`)
};

const en_notifications_email_subject_price_drop = /** @type {(inputs: Notifications_Email_Subject_Price_DropInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Price drop: ${i?.itemName} — ${i?.current} (was ${i?.previous})`)
};

/**
* | output |
* | --- |
* | "Price drop: {itemName} — {current} (was {previous})" |
*
* @param {Notifications_Email_Subject_Price_DropInputs} inputs
* @param {{ locale?: "he" | "en" }} options
* @returns {LocalizedString}
*/
export const notifications_email_subject_price_drop = /** @type {((inputs: Notifications_Email_Subject_Price_DropInputs, options?: { locale?: "he" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Notifications_Email_Subject_Price_DropInputs, { locale?: "he" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "he") return he_notifications_email_subject_price_drop(inputs)
	return en_notifications_email_subject_price_drop(inputs)
});